import React from 'react';
import { Landmark } from './Landmark';
import { ConcreteRoles } from './roles';

export interface BannerProps {}

export const Banner: React.FC<BannerProps> = props => {
  return <Landmark role={ConcreteRoles.banner} {...props} />;
};
